<template>
  <div
    :class="{ 'open-item': maxHeight != '0px', disabledx: disabled }"
    class="vs-collapse-item vx-collapse-item"
    @mouseover="mouseover"
    @mouseout="mouseout"
  >
    <header class="vs-collapse-item--header" @click="toggleContent">
      <slot name="header"></slot>
      <span
        v-if="!notArrow"
        class="icon-header vs-collapse-item--icon-header"
        :style="iconStyleContent"
      >
        <vs-icon :icon-pack="iconPack" :icon="iconArrow" />
      </span>
    </header>
    <div
      ref="content"
      :style="styleContent"
      class="vs-collapse-item--content flex flex-col flex-grow flex-shrink"
    >
      <div class="con-content--item">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "VxCollapseItem",
  components: {},
  props: {
    open: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    notArrow: {
      default: false,
      type: Boolean,
    },
    iconArrow: {
      default: "keyboard_arrow_down",
      type: String,
    },
    iconPack: {
      default: "material-icons",
      type: String,
    },
    sst: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    maxHeight: "0px",
    dataReady: false,
    isOpen: false,
  }),
  computed: {
    accordion() {
      return this.$parent.accordion;
    },
    openHover() {
      return this.$parent.openHover;
    },
    styleContent() {
      return {
        maxHeight: this.maxHeight,
        minHeight: this.minHeight,
        height: this.height,
      };
    },
    iconStyleContent() {
      return {
        transform: this.isOpen
          ? "translate(-50%,-50%) rotate(180deg)"
          : "translate(-50%,-50%)",
      };
    },
  },
  watch: {},
  mounted() {
    this.isOpen = this.open;
  },
  methods: {
    changeHeight() {
      const maxHeightx = this.$refs.content.scrollHeight;
      if (this.maxHeight != "0px") {
        this.maxHeight = `${maxHeightx}px`;
      }
    },
    toggleContent() {
      if (this.openHover || this.disabled) return;

      if (this.accordion) {
        this.$parent.closeAllItems(this.$el);
      }

      if (this.sst && !this.dataReady) {
        this.$emit("fetch", {
          done: () => {
            this.initMaxHeight();
            this.dataReady = true;
          },
        });
      } else {
        this.isOpen = !this.isOpen;
        this.initMaxHeight();
      }
    },
    initMaxHeight() {
      const maxHeightx = this.$refs.content.scrollHeight;
      if (this.isOpen) {
        this.maxHeight = `${maxHeightx}px`;
        setTimeout(() => {
          this.maxHeight = `max-content`;
        }, 300);
      } else {
        this.maxHeight = `${maxHeightx}px`;
        setTimeout(() => {
          this.maxHeight = `0px`;
        });
      }
    },
    mouseover() {
      if (this.disabled) return;
      let maxHeightx = this.$refs.content.scrollHeight;
      if (this.openHover) {
        this.maxHeight = `${maxHeightx}px`;
      }
    },
    mouseout() {
      if (this.openHover) {
        this.maxHeight = `0px`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.vx-collapse-item {
  height: fit-content;
}
</style>
